export const GAME_CATEGORIES = [
  'these ones vibe',
  'at least one letter',
  'start with a letter from the alphabet',
  'could be in a book',
  'without any numbers in them',
  'found in the dictionary',
  'can be translated into other languages',
  'can be typed with a keyboard',
  'instantly make you think of words',
  'have at least one syllable',
  'can be spoken by a human',
  'found on the internet',
  'open to having a synonym',
  'can be used in a sentence',
  'could be in a poem',
  'can be sung',
  'could write it on a piece of paper',
  'has less than 100 characters',
  'has less than 400 syllables',
  'looks good in other fonts',
  'open to being in a book',
  'you might have said it before',
  'has a sound',
  'could be a word of the year',
  'it a words',
  'ooo banana!',
  'i have a concept on how they could be related',
  'hold on i dropped some words on the floor',
  'oops all letters',
  'i just saw it in a movie',
];

export const GAME_WORDS = [
  'fireplace',
  'an aura reading',
  'a smol crystal',
  'stripes',
  'garage',
  'homework',
  'tabletop',
  'old vehicle',
  'crimping',
  'walrus',
  'pinecone',
  'swamp',
  'the',
  'sapphire',
  'vertical',
  'lily',
  'rope',
  'quaint',
  'earth',
  'orchid',
  'huge',
  'trampoline',
  'yellow',
  'house',
  'cloud',
  'ancient',
  'found',
  'ocean',
  'disc',
  'brazen',
  'lump',
  'slapped',
  'drizzle',
  'hollow',
  'pit',
  'release',
  'silence',
  'frozen',
  'splashed',
  'spiderweb',
  'sour',
  'gummy worm',
  'elegant',
  'moon',
  'shadow',
  'cutscene',
  'rising',
  'autumn',
  'sixty',
  'kingdom',
  'storefront',
  'concurrent',
  'magma bell',
  'localization',
  'premium',
  'lengthy',
  'marrow',
  'debt financed',
  'sleepy cat',
  'scarecrow',
  'drifting',
];
